import { message } from "antd";
import { buildToastInstance } from "./abstract.js";
import { useContext } from "react";
import { ToastProvider, ToastProviderContext } from "./provider.js";
import "./styles.css";
export * from "./ToastPanel.js";
const useToast = ()=>{
    const toastInstance = useContext(ToastProviderContext);
    if (!toastInstance) return buildToastInstance(message);
    return toastInstance;
};
const staticToast = buildToastInstance(message);
staticToast.useToast = useToast;
staticToast.destroy = message.destroy;
export { ToastProvider, staticToast as message, staticToast as toast, useToast };
